module.exports = __webpack_public_path__ + "img/idcard-just.db72fedb.png";